import React, { useId } from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const IconBasePin = styled(IconBase) `
  --icon-active-color: ${({ theme }) => theme.primary.background};
`;
const Active = styled.g `
  --icon-color: var(--icon-active-color);

  fill: var(--icon-color);
`;
const Circle = styled.circle `
  transform: scale(var(--pin-icon-fill-scale, 0));
  transform-origin: 50% 100%;
`;
export const IconPin = (props) => {
    const id = useId();
    return (React.createElement(IconBasePin, { ...props },
        React.createElement("g", { strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("path", { d: "M9.99992 12.7084H3.95825V10.4167L4.27202 10.1029C5.40506 8.96988 6.04159 7.43316 6.04159 5.83081V4.79169C6.04159 3.41098 7.16087 2.29169 8.54158 2.29169H11.4583C12.839 2.29169 13.9583 3.41098 13.9583 4.79169V5.83081C13.9583 7.43316 14.5948 8.96988 15.7278 10.1029L16.0416 10.4167V12.7084H9.99992ZM9.99992 12.7084V17.7084", style: { stroke: 'var(--icon-color)' } }),
            React.createElement("defs", null,
                React.createElement("clipPath", { id: `pin-path-mask-${id}` },
                    React.createElement(Circle, { cx: (props.viewportSizeX || 20) / 2, cy: props.viewportSizeY || 20, r: props.viewportSizeY || 20 }))),
            React.createElement(Active, { clipPath: `url(#pin-path-mask-${id})` },
                React.createElement("path", { d: "M11.4583 2.29169H8.54158C7.16087 2.29169 6.04159 3.41098 6.04159 4.79169V5.83081C6.04159 7.43316 5.40506 8.96988 4.27202 10.1029L3.95825 10.4167V12.7084H9.99992H16.0416V10.4167L15.7278 10.1029C14.5948 8.96988 13.9583 7.43316 13.9583 5.83081V4.79169C13.9583 3.41098 12.839 2.29169 11.4583 2.29169Z", fillOpacity: "0.2", style: { fill: 'var(--icon-color)' } }),
                React.createElement("path", { d: "M9.99992 12.7084H3.95825V10.4167L4.27202 10.1029C5.40506 8.96988 6.04159 7.43316 6.04159 5.83081V4.79169C6.04159 3.41098 7.16087 2.29169 8.54158 2.29169H11.4583C12.839 2.29169 13.9583 3.41098 13.9583 4.79169V5.83081C13.9583 7.43316 14.5948 8.96988 15.7278 10.1029L16.0416 10.4167V12.7084H9.99992ZM9.99992 12.7084V17.7084", style: { stroke: 'var(--icon-color)' } })))));
};
//# sourceMappingURL=Pin.js.map